import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  catchError,
  map,
  Observable,
  publishReplay,
  refCount,
  throwError,
} from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LibraryService {
  libraryItems?: Observable<any[]> | null = null;
  libraryCodes?: Observable<any[]> | null = null;
  cachedResource: any;
  cacheTime = new Date();
  cacheLifetime = 1 * 60 * 1000;

  constructor(private http: HttpClient) {}

  fetchAll(): Observable<any[]> {
    const now = new Date();
    if (
      !this.libraryItems ||
      Math.abs(now.getTime() - this.cacheTime.getTime()) > this.cacheLifetime
    ) {
      this.cacheTime = new Date();
      this.libraryItems = this.http
        .get<any>(environment.apiUrl + '/library_items', {
          //environment.apiUrl + this.slug
          responseType: 'json',
        })
        .pipe(
          map((responseData) => {
            return responseData._embedded.library_items;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount(),
        );
    }

    return this.libraryItems;
  }

  checkCode(code: string) {
    let params = new HttpParams();
    params = params.append('code', code);

    return this.http
      .get<any>(environment.apiUrl + '/library_codes', {
        responseType: 'json',
        params,
      })
      .pipe(
        map((responseData) => {
          const results = responseData['_embedded'].library_codes[0];
          return results;
        }),
        catchError(this.handleError),
      );
  }

  confirmCode(code: string) {
    this.clearCache();
    const payload = {
      code,
    };
    return this.http.post<any>(environment.apiUrl + '/library_codes', payload, {
      observe: 'response',
    });
  }

  clearCache() {
    this.libraryItems = null;
    this.libraryCodes = null;
  }

  fetchCodes(): Observable<any[]> {
    const now = new Date();
    if (
      !this.libraryCodes ||
      Math.abs(now.getTime() - this.cacheTime.getTime()) > this.cacheLifetime
    ) {
      this.cacheTime = new Date();
      this.libraryCodes = this.http
        .get<any>(environment.apiUrl + '/library_codes', {
          //environment.apiUrl + this.slug
          responseType: 'json',
        })
        .pipe(
          map((responseData) => {
            return responseData._embedded.library_codes;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount(),
        );
    }

    return this.libraryCodes;
  }

  private handleError(errorRes: HttpErrorResponse) {
    // console.log(errorRes);
    let errorMessage =
      'An unknown error occurred.  If the problem persists please contact us.';
    if (!errorRes.statusText) {
      return throwError(errorMessage);
    }

    switch (errorRes.statusText) {
      case 'Unprocessable Entity':
        errorMessage = 'The data could not be processed.';
        errorMessage += errorRes.error?.validation_messages;
        break;
      case 'Not Found':
        errorMessage = 'The code is not valid.';
        break;
    }
    return throwError(errorMessage);
  }

  public generateCodes(itemIds: string, count: any, days: any) {
    const payload = {
      itemIds,
      count,
      days,
    };
    return this.http.post<any>(environment.apiUrl + '/library_codes', payload, {
      observe: 'response',
    });
  }
}
